import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";

export function selectedResourceCollectionReducer(
    state = initialState.selectedResourceCollection, action
) {
    switch(action.type) {
        case types.FETCH_SELECTED_RESOURCE_COLLECTION:
          return state;
        case types.UPDATE_SELECTED_RESOURCE_COLLECTION:
            return {
                ...state,
                name: action.payload.name,
                id: action.payload.id,
                key: action.payload.key
            };
        default:
          return state;
      }
}